"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.msalConfig = exports.loginRequest = void 0;
var _msalBrowser = require("@azure/msal-browser");
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const msalConfig = exports.msalConfig = {
  auth: {
    clientId: 'ba64d1d5-1342-4e1d-97f5-fc82a64fc178',
    // This is the ONLY mandatory field that you need to supply.
    authority: 'https://login.microsoftonline.com/d7437916-ec28-4dfd-bd6c-a55bf51863a7',
    // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: '/',
    // Points to window.location.origin. You must register
    // this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/',
    // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false // If "true", will navigate back to the original request location before processing the auth code response.
  },

  cache: {
    cacheLocation: 'localStorage',
    // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },

  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (level === _msalBrowser.LogLevel.Error) {
          // eslint-disable-next-line no-console
          console.error(message);
        }
      }
    }
  }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const loginRequest = exports.loginRequest = {
  scopes: []
};